import { Injectable } from '@angular/core';
import { InsightsRestService } from '../service/insights-rest-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FipsObject } from './fips-object';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FipsService extends InsightsRestService {

  private cbsasCache$: Observable<FipsObject[]>;
  private statesCache$: Observable<FipsObject[]>;

  constructor(private http: HttpClient) {
    super();
  }

  findAllCbsas(): Observable<FipsObject[]> {
    if (!this.cbsasCache$) {
      const url = this.buildUrl("/fips/cbsa");
      this.cbsasCache$ = this.http.get(url)
        .pipe(
          map((results: any[]) => results.map((result: any) => new FipsObject(result))),
          shareReplay(1)
        );
    }
    return this.cbsasCache$;
  }

  findAllStates(): Observable<FipsObject[]> {
    if (!this.statesCache$) {
      const url = this.buildUrl("/fips/state");
      this.statesCache$ = this.http.get(url)
        .pipe(
          map((results: any[]) => results.map((result: any) => new FipsObject(result))),
          shareReplay(1)
        );
    }
    return this.statesCache$;
  }

}
